import { api } from '@/api';
import axios from 'axios';

const getAvailableLanguages = () => {
  return axios.get(`${process.env.REACT_APP_API_URL}/api/kyc/v1/investor/language`);
};
const setLanguage = ({ languageId }) => {
  return api.post('/api/kyc/v1/investor/language', { languageId });
};

export const investorLocalizationApi = {
  getAvailableLanguages,
  setLanguage
};
